<template>
  <div class="live">
    <!-- <img src="{{live.avatar}}"></img> -->
    <div class="user-path">
      <img style="border-radius: 50%;" :src="live.avatar" />
    </div>
    <div class="live-info">
      <div class="live-user-info">
        <div class="live-user">{{ live.userName }}</div>
        <span class="live-count">{{ isNaN(live.viewCount + 1) ? 0 : live.viewCount + 1 }}人次观看</span>
      </div>
      <div class="live-operation">
        <!-- <div class="live-title">{{ live.liveTitle }}</div> -->
        <div class="live-date">{{ live.startTime | formatDate('YYYY-MM-DD HH:mm') }}</div>
        <!-- <div class="iconfont icon-home-fill"></div> -->
        <!-- <div class="home" bindtap="gotoHome">
          <div>
            <svg-icon icon-class="exchange"/>
          </div>
          <span>回到首页</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import liveApi from '@/api/live';
import liveMixin from '@/mixins/liveCode';

export default {
  name: 'live-info',
  props: {
    live: {
      type: Object,
      required: true,
      default: () => {}
    },
    // 用于判断是否为分享后的视频页面引用
    isVisitor: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      userAvatar: '',
      isPraiseDisable: false,
      isPraise: false,
      praiseCount: 0
    };
  },
  created() {
    if (this.isVisitor) {
      let visitorInfo = localStorage.getItem('visitorInfo');
      this.userAvatar = visitorInfo.avatar;
    } else {
      let userInfo = localStorage.getItem('userInfo');
      console.log('222222222222222222:', userInfo);
      this.userAvatar = userInfo.avatar;
    }
  },
  computed: {
    ...mapGetters(['visitorInfo', 'userInfo']),
    /* userAvatar() {
      if (this.isVisitor) {
        let visitorInfo = localStorage.getItem('visitorInfo');
        console.log('11111111111111:', visitorInfo);
        return visitorInfo.avatar;
      } else {
        let userInfo = localStorage.getItem('userInfo');
        console.log('222222222222222222:', userInfo);
        return userInfo.avatar;
      }
    }, */
    praiseImg() {
      return this.isPraise
        ? require('@/assets/iconPraised.png')
        : require('@/assets/iconPraise.png');
    }
  },
  mixins: [liveMixin],
  methods: {
    praise() {
      let mobile = this.userInfo.mobile;
      if (this.isVisitor) {
        if (!this.visitorInfo.mobile) {
          // 分享页，未登录
          const shareLive = this.$findComponentUpward(this, 'live-share-detail');
          shareLive && shareLive.showLogin();
          return;
        } else {
          mobile = this.visitorInfo.mobile;
        }
      }

      this.isPraiseDisable = true;
      const type = this.isPraise ? 0 : 1;
      console.log('type: ', type);
      const params = {
        id: this.id,
        liveId: this.liveId,
        userName: this.visitorInfo.realname || '',
        userPhone: mobile,
        authoMobile: this.live.userPhone
      };
      liveApi.addPraise(params).then(response => {
        if (response.result) {
          //   this.isPraise = !this.isPraise;
          //   if (type) {
          //     this.praiseCount += 1;
          //   } else {
          //     this.praiseCount -= 1;
          //   }
          if (this.isVisitor) {
            const shareLiveDetail = this.$findComponentUpward(this, 'live-share-detail');
            shareLiveDetail && shareLiveDetail.getLiveDetail(true);
          } else {
            const liveDetail = this.$findComponentUpward(this, 'live-detail');
            liveDetail && liveDetail.getLiveDetail(true);
          }
        }

        this.isPraiseDisable = false;
      });
    },
    share() {
      this.$store.commit('SET_CURRENT_LIVE_ITEM', this.live);
      this.$router.push('/share');
      /* const href = this.$getLiveShareUrl({
        id: this.id,
        liveId: this.liveId,
        streamCode: this.streamCode,
        userPhone: this.live.userPhone
      });
      const shareLive = {
        title: this.live.title,
        content: '点击观看课堂精彩内容',
        icon: this.$getShareIcon('live'),
        href
      };
      this.$share(this, shareLive); */
    }
  },
  watch: {
    'live.isPraise'() {
      this.isPraise = this.live.isPraise;
      this.praiseCount = parseInt(this.live.praiseCount, 10);
    }
  }
};
</script>

<style lang="less">
.live {
  height: 55px;
  display: flex;
  margin: 1px 10px;
  padding-top: 5px;
}

.live img {
  width: 45px;
  height: 45px;
}

.user-path {
  margin-right: 10px;
}

.user-path img {
  border-radius: 50%;
}

.live-info {
  /* border-bottom: 3rpx solid #e8e8e8; */
  /* height: 170rpx; */
  text-align: left;
  width: calc(100% - 32px);
  padding: 8px 16px;
}

.live-info span {
  font-size: 0.32rem;
  // color: #787878;
  color: #fff;
  // line-height: 1.8;
  background: #1980ff;
  border-radius: 16px;
  padding: 4px 8px;
}

.live-user-info {
  display: flex;
  align-items: center;
  margin-top: 4px;
  margin-bottom: 5px;
}

.live-user {
  font-size: 0.32rem;
}

.live-count {
  position: absolute;
  right: 10px;
  font-size: 0.32rem;
}

.live-operation {
  width: 100%;
  // display: flex;
  align-items: center;
  color: #787878;
}

.live-title {
  // float: left;
  font-size: 0.3rem;
  margin: 5px 0;
}

.live-date {
  // float: left;
  font-size: 0.3rem;
  margin-top: 8px;
}

.home {
  display: flex;
  align-items: center;
  position: absolute;
  right: 10px;
  padding: 0 13px;
  border: 1px solid #787878;
  border-radius: 10px;
}

.icon-home-fill {
  font-size: 0.32rem;
}
</style>
